import { $, _ } from 'wgnet-awesomejs';
import BaseInput from 'source/lib/component/input/base';
import Settings from 'source/lib/settings_model';
import messages from 'messages';

import template from './template.html';
import hint from './hint_content.html';

const LoginInput = BaseInput.extend({
    name: 'login-input',
    template,
    bindHint() {
        this.$hint = $('.js-form-field-hint');
        this.$hintContent = this.$('.js-form-field-hint-content');

        this.events['focus input'] = 'showHint';
        this.events['blur input'] = 'hideHint';
    },
    showHint() {
        const state = this.$hint.data('current-state');
        if (state === 'error') {
            this.$hint.show();
        }
    },
    hideHint() {
        this.$hint.hide();
    },
    setHint(state, rendered) {
        this.$hint.data('current-state', state);
        this.$hintContent.html(rendered);
    },
    initialize(...args) {
        BaseInput.prototype.initialize.call(this, ...args);

        this.bindHint();

        this.delegateEvents();
        this.$root.on('component:all:login-validated', this.onValidated.bind(this));
    },
    keyup(event = {}) {
        BaseInput.prototype.keyup.call(this, event);
        if (Settings.get('Request.BadEmailDomains', []).length > 0) {
            this.components.proxyEvent('check', event, this);
        }
    },
    getMessage(message) {
        return _.extract(messages, `errors.login.${message}`);
    },
    onValidated(event, { result }) {
        const loginError = _.extract(result, 'responseJSON.errors.login', [])[0];
        const message = this.getMessage(loginError);
        if (message) {
            this.setHint('error', hint({
                error: message,
            }));
            this.showHint();
            this.isErrored = true;
        } else {
            this.isErrored = false;
            this.setHint('no-hint', hint({}));
            this.hideHint();
        }
    },
    setHintDescription() {},
});

export default LoginInput;
